// The Workflow Definitions table on the Work landing (brief §5.1): a column-head row plus one
// DefinitionRow per definition the projection lists, inside the house Panel. An empty projection
// renders the honest empty state (P-SELF) — never a fabricated row; the definitions appear the
// moment a workflow is activated and swept onto its cadence.

import { EmptyState, Panel } from '../../../primitives.tsx';
import type { WorkLandingDefinitionRow } from '../../projections.ts';
import { DEF_GRID, DefinitionRow } from './DefinitionRow.tsx';

const HEAD_LABEL = 'ritona-numeric text-xs uppercase tracking-eyebrow text-text-subtle';

export interface DefinitionListProps {
  readonly definitions: readonly WorkLandingDefinitionRow[];
  readonly onOpenBoard: (definitionId: string) => void;
}

/** The definitions table (or the honest empty state when nothing is activated yet). */
export function DefinitionList({
  definitions,
  onOpenBoard,
}: DefinitionListProps): React.JSX.Element {
  if (definitions.length === 0) {
    return (
      <Panel>
        <EmptyState>
          No workflows yet. When one is activated it appears here with its sweep cadence.
        </EmptyState>
      </Panel>
    );
  }
  return (
    <Panel>
      <div className={`${DEF_GRID} px-5 pb-3 pt-4`}>
        <span className={HEAD_LABEL}>Workflow</span>
        <span className={HEAD_LABEL}>Items</span>
        <span className={HEAD_LABEL}>Decisions</span>
        <span className={`hidden lg:block ${HEAD_LABEL}`}>Last sweep</span>
        <span />
      </div>
      <ul
        aria-label="Workflow definitions"
        className="divide-y divide-border border-t border-border"
      >
        {definitions.map((row) => (
          <li key={row.id}>
            <DefinitionRow row={row} onOpenBoard={onOpenBoard} />
          </li>
        ))}
      </ul>
    </Panel>
  );
}
